const Navhome = () => {
 return (
  <svg
   width="24"
   height="24"
   viewBox="0 0 24 24"
   fill="none"
   xmlns="http://www.w3.org/2000/svg"
  >
   <g clip-path="url(#clip0_471_1788)">
    <path
     d="M23.121 9.06887L15.536 1.48287C14.5973 0.546856 13.3257 0.0212402 12 0.0212402C10.6744 0.0212402 9.40277 0.546856 8.46401 1.48287L0.879012 9.06887C0.599438 9.34665 0.377782 9.67717 0.226895 10.0413C0.0760072 10.4053 -0.0011104 10.7958 1.20795e-05 11.1899V21.0069C1.20795e-05 21.8025 0.316083 22.5656 0.878692 23.1282C1.4413 23.6908 2.20436 24.0069 3.00001 24.0069H21C21.7957 24.0069 22.5587 23.6908 23.1213 23.1282C23.6839 22.5656 24 21.8025 24 21.0069V11.1899C24.0011 10.7958 23.924 10.4053 23.7731 10.0413C23.6222 9.67717 23.4006 9.34665 23.121 9.06887ZM15 22.0069H9.00001V18.0729C9.00001 17.2772 9.31608 16.5142 9.87869 15.9515C10.4413 15.3889 11.2044 15.0729 12 15.0729C12.7957 15.0729 13.5587 15.3889 14.1213 15.9515C14.6839 16.5142 15 17.2772 15 18.0729V22.0069ZM22 21.0069C22 21.2721 21.8947 21.5264 21.7071 21.714C21.5196 21.9015 21.2652 22.0069 21 22.0069H17V18.0729C17 16.7468 16.4732 15.475 15.5355 14.5373C14.5979 13.5997 13.3261 13.0729 12 13.0729C10.6739 13.0729 9.40216 13.5997 8.46448 14.5373C7.5268 15.475 7.00001 16.7468 7.00001 18.0729V22.0069H3.00001C2.7348 22.0069 2.48044 21.9015 2.29291 21.714C2.10537 21.5264 2.00001 21.2721 2.00001 21.0069V11.1899C2.00094 10.9248 2.1062 10.6709 2.29301 10.4829L9.87801 2.89987C10.4417 2.3388 11.2047 2.02381 12 2.02381C12.7953 2.02381 13.5583 2.3388 14.122 2.89987L21.707 10.4859C21.8931 10.6731 21.9983 10.9259 22 11.1899V21.0069Z"
     fill="#6C7072"
    />
   </g>
   <defs>
    <clipPath id="clip0_471_1788">
     <rect width="24" height="24" fill="white" />
    </clipPath>
   </defs>
  </svg>
 );
};

export default Navhome;
